import { MobDef } from '../mob';
import { BlockId } from '@shared/block-ids';

export const SKELETON_DEF: MobDef = {
  name: 'Skeleton',
  width: 0.6,
  height: 1.8,
  health: 20,
  speed: 2.5,
  hostile: true,
  color: 0xcccccc,
  bodyColor: 0xaaaaaa,
  detectionRange: 16,
  attackDamage: 2,
  attackRange: 2,
  drops: [
    { id: BlockId.COBBLESTONE, min: 0, max: 2 },
  ],
};
